import React from 'react'
import { formatTimeForBidderConfig } from 'apps/spot-quote-control-panel/utils/formatTimeForBidderConfig'
import { NotAvailableIcon, SuccessIcon } from 'transfix-icons'

interface IActiveJobRun {
  activeJobRunStart?: string | null
}

export const ActiveJobRun = ({ activeJobRunStart }: IActiveJobRun) => {
  if (activeJobRunStart) {
    const time = formatTimeForBidderConfig(activeJobRunStart)
    return (
      <span>
        <SuccessIcon color='skyBlue6' /> {time}
      </span>
    )
  }
  return <NotAvailableIcon />
}
